import { styled } from '../../Utilities';
import { DetailsColumnBase } from './DetailsColumn.base';
import { getDetailsColumnStyles } from './DetailsColumn.styles';
export var DetailsColumn = styled(DetailsColumnBase, getDetailsColumnStyles, undefined, {
  scope: 'DetailsColumn'
});